var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72 6.129v-.141c0-.333.06-.609.184-.826.123-.224.271-.413.445-.565a8.81 8.81 0 0 1 .533-.434c.18-.138.333-.286.456-.446a.995.995 0 0 0 .184-.608.88.88 0 0 0-.293-.673c-.188-.189-.467-.283-.836-.283-.391 0-.695.094-.913.283-.21.188-.344.467-.402.836H.036c.043-.478.163-.894.358-1.249.203-.355.478-.63.826-.826.347-.202.756-.304 1.227-.304.485 0 .894.094 1.227.283.334.18.587.423.76.728.182.304.272.644.272 1.02 0 .377-.068.685-.206.924a2.196 2.196 0 0 1-.51.608 8.89 8.89 0 0 1-.598.467 2.82 2.82 0 0 0-.5.467.956.956 0 0 0-.206.63v.109h-.967Zm.532 2.39a.796.796 0 0 1-.554-.207.745.745 0 0 1-.229-.565c0-.231.076-.42.229-.565a.754.754 0 0 1 .554-.228c.217 0 .398.076.543.228a.745.745 0 0 1 .228.565c0 .232-.076.42-.228.565a.758.758 0 0 1-.543.207Z",
    fill: "#fff"
  })));
};

export default SvgQuestionMark;